/*
 * @Author: yan.chaoming 
 * @Date: 2018-02-08 11:04:46 
 * @Last Modified by: yan.chaoming
 * @Last Modified time: 2018-02-08 13:47:44
 */

export default {
  name: "login",
  
};


// WEBPACK FOOTER //
// ./src/projects/huayu/config/dev/login.js